import React from 'react';
import { Icon } from '@iconify/react';

const Skills = ({ sectionName, skills, skillsList }) => {
    const Skills = skillsList.map((skill, i) => {
        const skill_category = skills[skill].map((sk, idx) => {
            const style = sk.style ? { ...sk.style, fontSize: '140%' } : { fontSize: '140%' };
            return (
                <li className="list-inline-item mx-auto" key={idx}>
                    {sk.class === 'iconify' ? (
                        <div key={idx} className="mx-5">
                            <Icon icon={sk.dataIcon} style={style} />
                            <div className="text-center">
                                <p
                                    className="text-center"
                                    style={{ fontSize: '30%', marginTop: '4px', color: 'black' }}
                                >
                                    {sk.name}
                                </p>
                            </div>
                        </div>
                    ) : (
                        <div key={idx} className="mx-3">
                            <span>
                                <div className="text-center skills-tile">
                                    <i className={sk.class} style={{ fontSize: '130%' }}>
                                        <p className="text-center" style={{ fontSize: '30%', marginTop: '4px' }}>
                                            {sk.name}
                                        </p>
                                    </i>
                                </div>
                            </span>
                        </div>
                    )}
                </li>
            );
        });

        return (
            <div key={i} className="mt-3">
                <span className="text-black">{skill}</span>
                <ul className="list-inline mx-auto skill-icon">{skill_category}</ul>
                {i === skillsList.length - 1 ? (
                    <></>
                ) : (
                    <hr className="text-black" style={{ width: '80%', margin: '0 auto' }} />
                )}
            </div>
        );
    });

    return (
        <section id="skills">
            <div className="col-md-12">
                <div className="col-md-12">
                    <h1 className="section-title">
                        <span className="text-black">{sectionName}</span>
                    </h1>
                </div>
                <div className="col-md-12 text-center">
                    <ul className="list-inline mx-auto skill-icon">{Skills}</ul>
                </div>
            </div>
        </section>
    );
};

export default Skills;
